import 'Debug';

export default class Component {

  constructor(App, namespace) {
    this.App = App || null;
    this.namespace = namespace || null;
    this.createLogger();
  }

  createLogger() {
    localStorage.debug = 'App.*';
    let name = this.constructor.name === 'App' ? 'Core' : this.constructor.name;
    name = (this.namespace ? `${this.namespace}.` : '') + name;
    this.logger = debug(`App.${name}`);
  }

  configure() {
    // this.logger('✅️ Configured');
    return this;
  }

  initialize() {
    // this.logger('🚀 Initialized');
    return this;
  }

}